'use strict';

/**
 * Enum definition file for price tag editable field types.
 *
 * @module data/enums/price-tag-field-types
 */
module.exports = {
    percent: 'percent',
    money: 'money',
    integer: 'integer',
    text: 'text',
    boolean: 'boolean',
};
